module.exports = __webpack_public_path__ + "static/media/webpay.bd277109.png";